<ds-breadcrumb>
  <ds-breadcrumb-item routerLink="/dashboard">
    {{ 'dashboard.breadcrumb.label' | translate }}
  </ds-breadcrumb-item>
  @for (item of breadcrumbs(); track $index) {
    <ds-breadcrumb-item [routerLink]="item.url">
      {{ item.translate ? (item.label | translate) : item.label }}
    </ds-breadcrumb-item>
  }
</ds-breadcrumb>
